export const RegisterTypes = {
  RESET_REGISTER_PAGE: 'RESET_REGISTER_PAGE',
  RQ_REGISTER: 'RQ_REGISTER',
  REGISTER_SUCCESS: 'REGISTER_SUCCESS',
  REGISTER_ERROR: 'REGISTER_ERROR',
  REGISTER_FINISH: 'REGISTER_FINISH',
  REGISTER_CONTROL_CODE: 'REGISTER_CONTROL_CODE',
  REGISTER_SEND_CODE_TO_USER: 'REGISTER_SEND_CODE_TO_USER',
}
